<template>
  <main class="container-1">
    <Login>
    </Login>
  </main>
</template>

<script>
import Login from '@/components/Login.vue'
import {landingRouteForPermissions} from '@/components/mixin/navigationRoutes.js'

export default {
  name: 'home',

  data() {
    return {

    }
  },

  components: {
    Login
  },

  computed: {

  },

  props: [],

  methods: {
    hello: function() {
      console.log('Hello');
    },
  },

  updated() {

  },

  created() {
    // Si el enlace de campaña pidió autenticación, el único destino aceptado
    // después del ingreso es una ruta interna de campaña.
    const returnTo = this.$route.query.returnTo;
    const campaignReturn = typeof returnTo === 'string' && /^\/terreno\/campanas\/[^/?#]+$/.test(returnTo)
      ? returnTo
      : null;
    // El destino sale del menú del propio usuario. Antes era siempre /visor, así que
    // quien no tenía ese permiso terminaba en "página no encontrada" al iniciar sesión.
    const destination = campaignReturn || landingRouteForPermissions(this.$store.getters.getPermissions);
    if (destination) {
      this.$router.push(destination)
    }
  },

  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.container-1 {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
